import React from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Spinner } from 'react-bootstrap';

const RatingMetrics = ({ loading, ratingMetrics }) => {
  const cellStyle = (rowData, field, threshold) => {
    const value = rowData[field];
    const color = value < threshold ? 'red' : 'green';
    return { color };
  };

  const renderCell = (field, threshold) => (rowData) => (
    <span style={cellStyle(rowData, field, threshold)}>{rowData[field]}</span>
  );

  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center justify-content-center" style={{ height: '317px' }}>
          <Spinner />
        </div>
      ) : null}

      <DataTable
        value={loading ? [] : ratingMetrics}
        paginator={false}
        rows={5}
        emptyMessage={
          !loading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                color: '#495057',
                fontWeight: 400,
                height: '317px',
              }}
            >
              No Data Found
            </div>
          ) : null
        }
      >
        <Column field="Rating" header="Rating Metrics" className="rating_metrics" />
        <Column
          header="Current"
          body={(rowData) => {
            switch (rowData?.Rating) {
              case 'Average Rating':
                return renderCell('DaysCurrent', 3.5)(rowData);
              case 'On Time Submission Ratio %':
                return renderCell('DaysCurrent', 90)(rowData);
              default:
                return renderCell('DaysCurrent', 70)(rowData);
            }
          }}
        />
        <Column
          header="30 Days"
          body={(rowData) => {
            switch (rowData?.Rating) {
              case 'Average Rating':
                return renderCell('Days30', 3.5)(rowData);
              case 'On Time Submission Ratio %':
                return renderCell('Days30', 90)(rowData);
              default:
                return renderCell('Days30', 70)(rowData);
            }
          }}
        />
        <Column
          header="180 Days"
          body={(rowData) => {
            switch (rowData?.Rating) {
              case 'Average Rating':
                return renderCell('Days180', 3.5)(rowData);
              case 'On Time Submission Ratio %':
                return renderCell('Days180', 90)(rowData);
              default:
                return renderCell('Days180', 70)(rowData);
            }
          }}
        />
      </DataTable>
    </>
  );
};

export default RatingMetrics;
